var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Paper, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';
function filterOptions(t, state) {
    if (!state.inputValue) {
        return [];
    }
    return t;
}
export function Search(_a) {
    var initialValue = _a.value, placeholder = _a.placeholder, options = _a.options, onInput = _a.onInput, onChange = _a.onChange;
    var _b = useState([]), value = _b[0], setValue = _b[1];
    var _c = useState(null), element = _c[0], setElement = _c[1];
    var _d = useState(null), scrollElement = _d[0], setScrollElement = _d[1];
    var _e = useState(0), setLeft = _e[1];
    var _f = useState(-1), selectedTag = _f[0], setSelectedTag = _f[1];
    var autocompleteRef = useCallback(function (node) {
        var _a;
        if (node) {
            setElement(node);
            setScrollElement(((_a = node.firstElementChild) === null || _a === void 0 ? void 0 : _a.firstElementChild) || null);
        }
    }, []);
    useEffect(function () {
        setValue(initialValue);
        if (scrollElement && scrollElement.scrollTo) {
            setLeft(function (prev) {
                var next = scrollElement.scrollWidth;
                if (prev < next) {
                    scrollElement.scrollTo({ left: scrollElement.scrollWidth });
                }
                return next;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);
    return (_jsx(Autocomplete, { className: clsx('faq-filter-search-field'), classes: { popperDisablePortal: 'faq-filter-search-field--disable-portal' }, multiple: true, ref: autocompleteRef, value: value, onChange: function (_, newValue, reason) {
            if (reason === 'remove-option') {
                onChange(newValue);
                return;
            }
            var last = newValue.pop();
            onChange(__spreadArray(__spreadArray([], newValue, true), (last || '').split(/\s+/).filter(function (x) { return x; }), true));
        }, onInputChange: function (_, v, r) {
            onInput(v, r);
        }, freeSolo: true, options: options, filterOptions: filterOptions, disableClearable: true, disablePortal: true, onKeyDown: function (a) {
            if (selectedTag === -1) {
                return;
            }
            if (a.key === 'ArrowLeft' || a.key === 'ArrowRight') {
                setSelectedTag(-1);
            }
            if (a.key === 'Backspace' || a.key === 'Delete') {
                onChange(value.filter(function (_, i) { return i !== selectedTag; }));
            }
        }, renderTags: function (tagValue, getTagProps) {
            return tagValue.map(function (option, index) {
                var props = getTagProps({ index: index });
                return (_jsx(Chip, __assign({ variant: "outlined", label: option }, props, { className: clsx(props.className, 'faq-search-tag', {
                        selected: selectedTag === index,
                    }), onClick: function () {
                        setSelectedTag(index);
                    } }), option));
            });
        }, renderInput: function (params) {
            return _jsx(TextField, __assign({}, params, { variant: "outlined", placeholder: placeholder }));
        }, PaperComponent: function (props) {
            return (_jsx(Paper, __assign({ elevation: 0 }, props, { className: clsx('faq-filter-search-paper', props.className), style: { width: element === null || element === void 0 ? void 0 : element.clientWidth } })));
        } }));
}
//# sourceMappingURL=Search.js.map